var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 32,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 42H32.6667V26.25C32.6667 23.7799 29.8949 21.7135 27.4249 21.7135C24.9548 21.7135 23.3334 23.7799 23.3334 26.25V42H14V14H23.3334V18.6667C24.8787 16.1667 28.8316 14.5536 31.5584 14.5536C37.3252 14.5536 42 19.3167 42 25.0833V42ZM9.33333 42H0V14H9.33333V42ZM4.66669 0C7.24402 0 9.33336 2.08934 9.33336 4.66667C9.33336 7.244 7.24402 9.33333 4.66669 9.33333C2.08936 9.33333 2.3365e-05 7.244 2.3365e-05 4.66667C2.3365e-05 2.08934 2.08936 0 4.66669 0Z",
    fill: "#796F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.d65029df62f982c7eb51852a3fa32548.svg";
export { ForwardRef as ReactComponent };